import React, { useEffect, useMemo, useState } from 'react'
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom'
import { Tooltip } from 'antd';
import AnimatedNumber from "animated-number-react";
import { useAuth } from "../../providers/AuthProvider";
import HideTalentPricingTooltip from '../clients/HideTalentPricingTooltip';


const WrippleEstimateHorizontal = ({ project, team, candidate, showIncomplete, trademark, editable = true, style, className = '', ...props }) => {

    const trans = (componentKey, replace = {}) => {
        if (TB.isFunction(props.trans)) {
            return props.trans(
                componentKey, replace
            );
        }

        let translations = {
            est_price_label: 'ESTIMATED PRICE',
            est_price_tooltip: TB.trans('projects.wripple_cost_estimate.tooltip'),

            budget_label: 'BUDGET',
            bill_rate_label: 'AVG BILL RATE',

            base_price_label: 'BASE PRICE',
            base_price_tooltip: TB.trans('projects.wripple_cost_estimate.tooltip'),
            scope_edit_info_link: 'Answer scope questions to get a project estimate',
        };

        return translations[componentKey];
    }

    const shouldShowEstimate = () => {
        if (!project || !project.hasEstimate()) {

            return false;
        }

        if (TB.isObject(team)) {
            let cost = team.estimateWithServiceFeeFor(project);
            if (!cost) {
                return false;
            }
        }

        if (TB.isObject(candidate)) {
            let cost = candidate.estimated_cost;
            if (!cost) {
                return false;
            }
        }

        return true;
    }

    const renderTooltip = () => {
        return (
            <div className="est-header">
                {trademark && TB.isDefined(TB.logoEstimateIconPath()) && (
                    <img alt={laravel.platform_name} src={TB.logoEstimateIconPath()} className="logo-white" />
                )}

                <p>
                    {trans(shouldShowEstimate() ? 'est_price_label' : 'base_price_label')}
                </p>

                {trademark && (
                    <Tooltip
                        color="#913EF0"
                        placement="bottomRight"
                        title={trans(shouldShowEstimate() ? 'est_price_tooltip' : 'base_price_tooltip')}
                    >
                        <i className="fa fa-info-circle" />
                    </Tooltip>
                )}
            </div>
        );
    }


    const isEditable = project.canEditScope() && editable;

    const [duration, setDuration] = useState(0);
    const [showTeamHourlyTooltip, setShowTeamHourlyTooltip] = useState(false);

    useEffect(() => {
        setDuration(2500)
    }, []);



    let disciplineCosts = [];

    if (TB.isObject(team)) {
        disciplineCosts = team.disciplineBulkEstimatesFor(
            project
        );
    }

    if (!disciplineCosts) {
        disciplineCosts = [];
    }

    let containerClass = '';
    if (!shouldShowEstimate()) {
        containerClass = 'wripple-estimate-base-only';
        if (isEditable) {
            containerClass += ' wripple-estimate-base-editable';
        }
    }

    let totalDisciplineCost = TB.sumBy(disciplineCosts, 'estimate');

    const { auth } = useAuth();

    let displayedEstimate = useMemo(() => {
        let assignedCost = project.totalPeriodCost(false);
        if (assignedCost) {
            return assignedCost;
        }

        let estCost = project.platform_cost;

        if (!project.hasEstimate()
            && !TB.isNaN(parseInt(project.platform_cost))
            && parseInt(project.platform_cost) > 0) {
            estCost = project.platform_cost;
        }

        return parseInt(estCost)
    }, [project.totalHourlyCost?.(), project.platform_cost]);


    return (
        <div className={`wripple-estimate ${containerClass} ${className}`} style={style}>

            <div className="pricing">

                {renderTooltip()}

                <div className="est-range">

                    <div className={"range-row"}>
                        <div className="range-price">
                            {auth.canViewTalentPricing() ? (
                                <>
                                    {!project.hasConfirmedProjectScope() ? (
                                        <h2 className="flex flex-row items-start">
                                            <small><sup>$</sup></small>
                                            <AnimatedNumber
                                                value={displayedEstimate}
                                                formatValue={(value) => String(TB.formatCurrency(value)).replace("$", "")}
                                                duration={duration}
                                            />
                                            {/*{!trademark && (*/}
                                            {/*    <div className="inline-flex" style={{lineHeight: 0}}>*/}
                                            {/*        <InfoTooltip placement="top" type="white" iconColor="white" iconStyle={{marginLeft: '0.5rem'}}>*/}
                                            {/*            <p className="text-black py-1 px-1.5">*/}
                                            {/*                Pending Scope Call*/}
                                            {/*            </p>*/}
                                            {/*        </InfoTooltip>*/}
                                            {/*    </div>*/}
                                            {/*)}*/}
                                        </h2>
                                    ) : (
                                        <h2>
                                            <small><sup>$</sup></small>
                                            <AnimatedNumber
                                                value={displayedEstimate}
                                                formatValue={(value) => String(TB.formatCurrency(value)).replace("$", "")}
                                                duration={duration}
                                            />
                                        </h2>
                                    )}
                                </>
                            ) : (
                                <HideTalentPricingTooltip />
                            )}

                            {project.isBYO() && project.hasConfirmedProjectScope() && !project.hasRequestedSOW() &&
                                !TB.isDefined(candidate) && auth?.canViewProjectBrief(project) &&
                                editable && shouldShowEstimate() && (
                                    <Link to={{
                                        pathname: `${project.briefStep()}/cost`,
                                        search: '?viewDetails=true'
                                    }}>
                                        Details
                                    </Link>
                                )}

                            {!project.isBYO() && project.hasConfirmedProjectScope() && !TB.isDefined(team) && !TB.isDefined(candidate) && editable && shouldShowEstimate() && (
                                <Link to={{
                                    pathname: project.reviewLink(),
                                    search: '?fromBrief=true'
                                }} state={{ fromBrief: true }}>
                                    Edit
                                </Link>
                            )}
                        </div>

                    </div>
                </div>
            </div>

            {TB.isObject(team) && (
                <div className="budget">

                    <h4>{trans('bill_rate_label')}</h4>
                    <h4 id={`team-${team.id}-project-${project.id}-hourly-tooltip`}>
                        {project.hasEstimate()
                            ? team.averageHourlyRateFor(project)
                            : team.averageBillRate()}
                    </h4>



                    {/* TODO: team prop is not being used from parent component.
                        if being used in future, need to convert the tooltip below
                        to an ant tooltop (previously used reactstrap tooltop) */}


                    {/* {!TB.inProductionEnv() && (
                        <Tooltip placement="bottom"
                            target={`team-${team.id}-project-${project.id}-hourly-tooltip`}
                            isOpen={showTeamHourlyTooltip}
                            autohide={false}
                            innerClassName="team-hourly-tooltip-inner"
                            toggle={() => {
                                setShowTeamHourlyTooltip(!showTeamHourlyTooltip)
                            }}>

                            <table className="table">
                                <thead>
                                    <tr>
                                        <th>Discipline</th>
                                        <th>Rate/Hr</th>
                                        <th>Est Hours</th>
                                        <th>Bulk Est</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {disciplineCosts.map((discipline, i) => (
                                        <tr key={`team-${team.id}-project-${project.id}-discipline-${i}-row`}>
                                            <td className="text-left">
                                                {discipline.name}
                                            </td>
                                            <td>
                                                {TB.formatCurrency(discipline.hourly_rate)}
                                            </td>
                                            <td>
                                                {discipline.total_hours.toFixed(1)}
                                            </td>
                                            <td>
                                                {TB.formatCurrency(discipline.estimate)}
                                            </td>
                                        </tr>
                                    ))}

                                    <tr>
                                        <td className="text-right" colSpan="3">
                                            <b>Scope Subtotal</b>
                                        </td>
                                        <td>
                                            {TB.formatCurrency(totalDisciplineCost)}
                                        </td>
                                    </tr>

                                    {TB.isObject(project.engagement_lead) && (
                                        <tr>
                                            <td className="text-left">
                                                Engagement Lead
                                            </td>
                                            <td>
                                                {TB.formatCurrency(project.engagement_lead.hourly_rate)}
                                            </td>
                                            <td>
                                                {project.engagement_lead.total_hours.toFixed(1)}
                                            </td>
                                            <td>
                                                {TB.formatCurrency(project.engagement_lead.estimated_cost)}
                                            </td>
                                        </tr>
                                    )}

                                    <tr>
                                        <td className="text-right" colSpan="3">
                                            <b>Pre-Markup Subtotal</b>
                                        </td>
                                        <td>
                                            <b>{TB.formatCurrency(totalDisciplineCost + (project.engagement_lead ? project.engagement_lead.estimated_cost : 0))}</b>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left">
                                            <b>Platform Markup</b>
                                        </td>
                                        <td>
                                            {project.percent_markup * 100}%
                                        </td>
                                        <td>
                                            --
                                        </td>
                                        <td>
                                            {TB.formatCurrency((totalDisciplineCost + (project.engagement_lead ? project.engagement_lead.estimated_cost : 0)) * project.percent_markup)}
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-right" colSpan="3">
                                            <b>Total</b>
                                        </td>
                                        <td>
                                            <b>{TB.formatCurrency(team.estimated_cost)}</b>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </Tooltip>
                    )} */}
                </div>
            )}

            {TB.isObject(candidate) && (
                <div className="budget">
                    <h4>{trans('bill_rate_label')}</h4>
                    <h4>
                        {candidate.standardPlatformRate()}
                    </h4>
                </div>
            )}
        </div>
    );
}

WrippleEstimateHorizontal.propTypes = {
    editable: PropTypes.any,
    project: PropTypes.object,
    style: PropTypes.object,
    trademark: PropTypes.bool,
    trans: PropTypes.any,
};
export default WrippleEstimateHorizontal;